<template>
  <create-dialog
    width="80%"
    :title="title"
    @closeModal="$emit('closeModal', false)"
    @handleOpen="handleOpen"
    @validate="validateForm"
    ref="createDialog"
  >
    <template slot="form">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-6 col-xl-4">
          <fg-input
            type="text"
            :label="`${$t('common_words.code')}: *`"
            v-model="model.code"
            name="common_words.code"
            v-validate="modelValidations.code"
            :error="getError('common_words.code', true)"
            placeholder="..."
            @click="handleClickOnCode()"
          >
          </fg-input>
        </div>
        <div class="col-12 col-sm-12 col-md-6 col-xl-4">
          <fg-input
            type="text"
            :label="`${$t('common_words.name')}: *`"
            v-model="model.name"
            name="common_words.name"
            v-validate="modelValidations.name"
            :error="getError('common_words.name', true)"
            :placeholder="`${$t('common_words.name')}`"
            @blur="convertUppercase(model.name)"
          >
          </fg-input>
        </div>
        <div :class="`col-12 col-sm-12 col-md-6 col-xl-4`">
          <fg-input
            :label="`${$t('common_words.code_homologated')}: `"
            type="text"
            v-model="model.homologated_code"
            :placeholder="`${$t('common_words.code_homologated')}`"
          ></fg-input>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-sm-12 col-md-6 col-xl-3">
          <fg-input
            type="number"
            step=".01"
            min="0"
            :label="`${$t('common_words.value')}: ($) *`"
            v-model="model.amount"
            name="common_words.value"
            v-validate="modelValidations.amount"
            :error="getError('common_words.value', true)"
            placeholder=" ..."
            @change="onChangeAmount"
          >
          </fg-input>
        </div>
        <div class="col-12 col-sm-12 col-md-6 col-xl-3">
          <label>{{ $t('common_words.starting_date') }}: *</label>
          <br />
          <el-date-picker
            :picker-options="pickerOptions"
            :placeholder="`${$t('common_words.select2')}...`"
            class="shadow-sm required-start-date"
            v-model="model.start_date"
            value-format="yyyy-MM-dd"
          />
        </div>
        <div class="col-12 col-sm-12 col-md-6 col-xl-3">
          <div class="form-group has-label">
            <label>{{ $t('labor.payment_frequency') }}: *</label>
            <br />
            <el-select
              @change="
                selectAllFromSelect(
                  'model.payment_frequency',
                  paymentFrequencies
                )
              "
              clearable
              filterable
              class="select-primary custom-width-select shadow-sm required-payment-frequency"
              size="large"
              v-model="model.payment_frequency"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="option in paymentFrequencies"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="option.id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-6 col-xl-3">
          <fg-input
            type="number"
            min="0"
            :label="`${$t('labor.payment_limit')} (${$t(
              'common_words.days'
            )}): `"
            v-model="model.payment_limit"
            name="labor.payment_limit"
            v-validate="modelValidations.payment_limit"
            :error="getError('labor.payment_limit', true)"
            placeholder=" ..."
          >
          </fg-input>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-group has-label">
            <label>{{ $t('common_words.description') }}: </label>
            <br />
            <el-input
              maxlength="300"
              show-word-limit
              type="textarea"
              :rows="3"
              placeholder="..."
              v-model="model.description"
              class="shadow-sm"
            ></el-input>
          </div>
        </div>
        <div v-if="businesses.length > 2" class="col-12">
          <div class="form-group has-label">
            <label>{{ $t('common_words.companies2') }}: *</label>
            <br />
            <el-select
              collapse-tags
              @change="selectAllFromSelect('model.business_id', businesses)"
              clearable
              multiple
              filterable
              class="select-primary custom-width-select shadow-sm required-business"
              size="large"
              v-model="model.business_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="option in businesses"
                class="select-primary selected-all"
                :value="option.id"
                :label="option.name"
                :key="option.id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <select-component
          v-if="activities.length > 0"
          :disabled="model.excluded_activities_id.length > 0"
          :rowClass="`col-12 col-md-6`"
          :dataOptions="filteredActivities"
          @onChange="handleChangeSelected"
          :labelSelect="`${$t('labor.associated_activities')}:`"
          modelName="asociated_activities_id"
          :initialSelection="model.asociated_activities_id"
        />
        <select-component
          v-if="activities.length > 0"
          :disabled="model.asociated_activities_id.length > 0"
          :rowClass="`col-12 col-md-6`"
          :dataOptions="filteredActivities"
          @onChange="handleChangeSelected"
          :labelSelect="`${$t('labor.excluded_activities')}:`"
          modelName="excluded_activities_id"
          :initialSelection="model.excluded_activities_id"
        />

        <!--Exclude Sabado y Domingo-->
        <select-component
          v-if="activities.length > 0"
          :rowClass="`col-12 col-md-6`"
          :dataOptions="filteredActivities"
          @onChange="handleChangeSelected"
          :labelSelect="`${$t('labor.discount_saturday')}:`"
          modelName="discount_saturday_id"
          :initialSelection="model.discount_saturday_id"
        />
        <select-component
          v-if="activities.length > 0"
          :rowClass="`col-12 col-md-6`"
          :dataOptions="filteredActivities"
          @onChange="handleChangeSelected"
          :labelSelect="`${$t('labor.discount_sunday')}:`"
          modelName="discount_sunday_id"
          :initialSelection="model.discount_sunday_id"
        />

        <div class="col-12">
          <div class="form-group has-label">
            <label>{{ $t('labor.workers') }}:</label>
            <br />
            <el-select
              collapse-tags
              @change="selectAllFromSelect('model.worker_id', availableWorkers)"
              clearable
              multiple
              filterable
              class="select-primary custom-width-select shadow-sm required-worker"
              size="large"
              v-model="model.worker_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="option in availableWorkers"
                class="select-primary selected-all"
                :value="option.id"
                :label="`${option.name}`"
                :key="option.id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div v-if="isSuper()" class="col-12">
          <div class="form-group has-label">
            <label>{{ $t('common_words.modules') }}:</label>
            <br />
            <el-select
              collapse-tags
              @change="selectAllFromSelect('model.module_id', getModulesList)"
              clearable
              multiple
              filterable
              class="select-primary custom-width-select shadow-sm required-module"
              size="large"
              v-model="model.module_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="option in getModulesList"
                class="select-primary selected-all"
                :value="option.id"
                :label="`${option.name}`.replace(/^0 - /, '')"
                :key="option.id"
              ></el-option>
            </el-select>
          </div>
        </div>
      </div>
    </template>
  </create-dialog>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util';
import { convertFirstLetterUppercase } from 'src/util/Util.js';
import MixinDialog from 'src/mixins/mixin-dialog';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinTranslate from 'src/util/mixinTranslate';
import MixinValidations from 'src/mixins/forms/mixin-validations';
import ModuleClass from 'src/class/ModuleClass';

export default {
  name: 'edit-or-create-bonus',
  props: {
    syncDialog: {
      type: Object,
      default: () => {
        return { create: false, disabledField: false };
      },
    },
  },
  watch: {
    '$i18n.locale': ['getSelectAll'],
    syncDialog(newValue) {
      if (newValue.create) this.openModal('create', newValue.disabledField);
      else this.closeModal('create', newValue.disabledField);
    },
  },
  mixins: [
    MixinDialog,
    MixinForm,
    MixinLoading,
    MixinPermissions,
    MixinTranslate,
    MixinValidations,
  ],
  data() {
    return {
      paymentFrequencies: [
        { id: 'Diario', name: 'Diario' },
        { id: 'Quincenal', name: 'Quincenal' },
        { id: 'Mensual', name: 'Mensual' },
      ],
      businesses: [],
      workers: [],
      modules: [],
      activities: [],
      disabledField: false,
      model: {
        name: null,
        code: null,
        homologated_code: null,
        description: null,
        amount: null,
        start_date: null,
        worker_id: [],
        business_id: [],
        module_id: [],
        route: null,
        payment_frequency: null,
        payment_limit: null,
        asociated_activities_id: [],
        excluded_activities_id: [],
        discount_saturday_id: [],
        discount_sunday_id: [],
      },
      modelValidations: {
        name: { required: true },
        code: { required: true },
        amount: { required: true, min_value: 0 },
        payment_frequency: { required: true },
        payment_limit: { min_value: 1 },
      },
      moduleClass: new ModuleClass(this),
      isLoading: true,
      pickerOptions: {
        disabledDate(time) {
          const now = new Date();
          const sevenDaysAgo = new Date();

          sevenDaysAgo.setDate(now.getDate() - 8);

          return time <= sevenDaysAgo;
        },
      },
    };
  },
  computed: {
    getModulesList() {
      return this.moduleClass.formatLabelModule(this.modules);
    },

    //filtrar trabajadores segun empresa seleccionada
    availableWorkers() {
      const tmp = [...(this.model.worker_id || [])];

      if ((this.model.business_id || []).length > 0) {
        this.model.worker_id = [];
        const selected = (this.model.business_id || []).map(Number);
        const response = this.workers.filter((w) =>
          selected.includes(Number(w.business_id))
        );

        response.forEach((w) => {
          if (tmp.includes(0)) this.model.worker_id.push(w.id);
          else if (tmp.includes(w.id)) this.model.worker_id.push(w.id);
        });

        return this.concatAll(response);
      } else {
        return this.concatAll([]);
      }
    },

    //filtrar Actividades Asociadas segun empresa seleccionada
    filteredActivities() {
      if (!this.model.business_id || this.model.business_id.length === 0) {
        return [];
      }

      return this.concatAll(
        this.activities.filter((act) =>
          this.model.business_id.includes(act.business_id)
        )
      );
    },
  },
  methods: {
    convertUppercase(bonusesName) {
      const name = convertFirstLetterUppercase(bonusesName);
      this.model.name = name;
    },
    updateDisabledField(value) {
      this.disabledField = value;
    },
    handleOpen() {
      if (this.isLoading) {
        this.showHideLoading(true);
      }
      if (!this.model.isEdit) {
        this.model.business_id = this.selectElementsAsignFromModel(
          1,
          this.model.business_id,
          this.businesses
        );
      }
    },
    onChangeAmount() {
      if (this.model.isEdit) {
        this.model.start_date =
          this.model.amount != this.model.last_amount
            ? null
            : this.model.last_start_date;
      }
    },
    getSelectAll() {
      this.businesses = this.concatAll(this.businesses.splice(1));
    },
    handleClickOnCode() {
      if (!isset(this.model.code) && !this.model.isEdit) {
        const tableCode = JSON.parse(sessionStorage.getItem('tableCode'));
        this.codeGenerator('Master Bonuses', tableCode);
      }
    },
    validateForm() {
      return this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (!isset(this.model.business_id)) {
            return this.validationInputsRequired('business');
          } else if (!isset(this.model.payment_frequency)) {
            return this.validationInputsRequired('payment-frequency');
          } else if (!isset(this.model.start_date)) {
            return this.validationInputsRequired('start-date');
          } else {
            this.$emit('addEdit', this.model);

            return true;
          }
        }
      });
    },
    handleChangeSelected(data) {
      this.$set(this.model, data.name, data.selects);
    },
  },
  updated() {
    if (sessionStorage.getItem('editForm')) {
      const {
        id,
        name,
        code,
        homologated_code,
        description,
        activeValue,
        bonus_values,
        businesses,
        workers,
        modules,
        payment_frequency,
        payment_limit,
        asociated_activities,
        excluded_activities,
        discount_saturdays_activities,
        discount_sundays_activities,
      } = JSON.parse(sessionStorage.getItem('editForm'));

      const lastBonusValueDate =
        bonus_values && bonus_values[0] && bonus_values[0].start_date;

      this.model = {
        id,
        name,
        code,
        homologated_code,
        description,
        amount: activeValue,
        last_amount: activeValue,
        start_date: lastBonusValueDate,
        last_start_date: lastBonusValueDate,
        business_id: businesses.map((business) => business.id),
        worker_id: workers.map((worker) => worker.id),
        module_id: modules.map((mod) => mod.id),
        payment_frequency,
        payment_limit,
        asociated_activities_id: asociated_activities.map((act) => act.id),
        excluded_activities_id: excluded_activities.map((exc) => exc.id),
        discount_saturday_id: discount_saturdays_activities.map(
          (dsa) => dsa.id
        ),
        discount_sunday_id: discount_sundays_activities.map((dsa) => dsa.id),
        isEdit: true,
      };
      this.errors.clear();
      sessionStorage.removeItem('editForm');
    }
  },
  created() {
    if (this.isIndex()) {
      Promise.all([
        Axios.getMasters('businesses/only'),
        Axios.getMasters('modules/indexfield'),
        Axios.getMasters('works/workers/indexField'),
        Axios.getMasters('works/activities/onlybonusesactivities'),
      ])
        .then(
          ([
            response_businesses,
            response_modules,
            response_workers,
            response_activities,
          ]) => {
            this.businesses = this.concatAll(response_businesses.data.data);
            this.modules = this.concatAll(response_modules.data.data);
            this.workers = this.concatAll(response_workers.data.data);
            this.activities = this.concatAll(response_activities.data.data);
            this.isLoading = false;
            this.showHideLoading();
          }
        )
        .catch((error) => {
          this.isLoading = false;
          this.showHideLoading();
          this.showMessageErrors(error);
        });
    } else {
      this.isLoading = false;
      this.showHideLoading();
      this.showMessageAccess();
    }
  },
  beforeDestroy() {
    sessionStorage.removeItem('editForm');
    sessionStorage.removeItem('tableCode');
  },
};
</script>
